import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getPersonEmploymentCertificates = (personId) => {
  return dispatch => {
    dispatch({ type: "GET_PERSON_EMPLOYMENT_CERTIFICATES_LOADING" });
    api
      .employmentCertificatesGetPerson(personId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
        dispatch({ type: "GET_PERSON_EMPLOYMENT_CERTIFICATES_LOADING_DONE" });
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_PERSON_EMPLOYMENT_CERTIFICATES_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetPersonEmploymentCertificatesErrorAlertTitle",
          "Virhe henkilön työtodistusten haussa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_PERSON_EMPLOYMENT_CERTIFICATES_SUCCEEDED",
  payload: { employmentCertificates: data },
});

const operationFail = () => ({
  type: "GET_PERSON_EMPLOYMENT_CERTIFICATES_FAIL"
});
